import React, { useEffect, useState } from "react";
import SearchImg from "../../../assets/user/images/search1.svg";
import UserImg from "../../../assets/user/images/user.png";
import TrashImg from "../../../assets/user/images/trash.svg";
import Edit2 from "../../../assets/user/images/edit-2.svg";
import RightArrow from "../../../assets/user/images/right-arow.png";
import DatePicker from "react-datepicker";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";
import FileImg from "../../../assets/provider/images/file.jpg";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../../layouts/loader/Loader";
import { api } from "../../../utlis/user/api.utlis";
import toast from "react-hot-toast";
import ApiService from "../../../core/services/ApiService";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import moment from "moment";
import uploadImage from "../../../assets/admin/images/uploadImage.svg";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import {
  MultipleFile,
  SingleFile,
  communityLIMIT,
  totalPageCalculator,
} from "../../../utlis/common.utlis";
import { Formik, Field, Form, ErrorMessage } from "formik";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import * as Yup from "yup";
import { routes } from "../../../utlis/user/routes.utlis";
import { encode } from "base-64";

const MyCommunity = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedCommunityImages, setSelectedCommunityImages] = useState([]);
  const [selectedDeleteImages, setSelectedDeleteImages] = useState([]);
  const [creation, setCreate] = useState({
    status: false,
  });
  const [deleteCommunity, setDeleteCommunity] = useState({
    status: false,
    id: null,
  });
  const [editCommunity, setEditCommunity] = useState({
    status: false,
    id: null,
    title: null,
    description: null,
    cover_image: null,
  });

  const initialValues = {
    title: "",
    description: "",
    files: "",
  };

  const initialEditValues = {
    title: editCommunity.title ?? "",
    description: editCommunity.description ?? "",
    cover_image: "",
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required!"),
    description: Yup.string().required("Description is required!"),
    files: Yup.array()
      .of(
        Yup.mixed()
          .required("Community image is required")
          .test("fileSize", "File size is too large", (file) => {
            return file && file.size <= MultipleFile * 1024 * 1024;
          })
          .test("fileType", "Unsupported file type", (file) => {
            return (
              file &&
              ["image/jpeg", "image/png", "image/jpg"].includes(file.type)
            );
          })
      )
      .required("At least one image is required")
      .min(1, "At least one image is required")
      .max(3, "You can upload a maximum of 3 images"),
  });

  const validationEditSchema = Yup.object().shape({
    title: Yup.string().required("Title is required!"),
    description: Yup.string().required("Description is required!"),
    cover_image: Yup.mixed()
      .test(
        "fileSize",
        `File size is too large`,
        (value) => !value || (value && value.size <= SingleFile * 1024 * 1024)
      )
      .test("fileType", "Unsupported file type", (value) => {
        return value != "" && (value != null) & (value != undefined)
          ? ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
          : true;
      }),
  });

  const createCommunity = async (formValue) => {
    setLoading(true);
    let form = new FormData();
    form.append("title", formValue.title);
    form.append("description", formValue.description);
    formValue.files.forEach((image) => {
      form.append("cover_image", image);
    });
    const response = await ApiService.postAPIWithAccessTokenMultiPart(
      api.communityAdd,
      form
    );
    setCreate({ status: false });
    document.getElementById("add-community-form").reset();
    if (response.data.status) {
      toast.success(response.data.message);
      getCreatedList(api.communityList + `?page=${pageNum}&limit=${communityLIMIT}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const updateCommunity = async (formValue) => {
    setLoading(true);
    let form = new FormData();
    form.append("title", formValue.title);
    form.append("description", formValue.description);
    if (formValue.files.length !== 0) {
      formValue.files.forEach((image) => {
        if (!image.isLive) form.append("cover_image", image.file);
      });
    }
    if (selectedDeleteImages.length !== 0) {
      selectedDeleteImages.forEach((ele) => {
        form.append("deleteImageId[]", ele);
      });
    }
    const response = await ApiService.putAPIWithAccessTokenMultiPart(
      api.communityUpdate + `${editCommunity.id}`,
      form
    );
    setEditCommunity({
      status: false,
      id: null,
      title: null,
      description: null,
      cover_image: null,
    });
    document.getElementById("update-community-form").reset();
    setSelectedImages([]);
    setSelectedDeleteImages([]);
    setSelectedCommunityImages([]);
    if (response.data.status) {
      toast.success(response.data.message);
      getCreatedList(api.communityList + `?page=${pageNum}&limit=${communityLIMIT}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const deleteMyCommunity = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.communityDelete + `${deleteCommunity.id}`
    );
    setDeleteCommunity({ status: false, id: null });
    if (response.data.status) {
      toast.success(response.data.message);
      getCreatedList(api.communityList + `?page=${pageNum}&limit=${communityLIMIT}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const getCreatedList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("my community listing => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setList(response.data.data.communityList);
      setTotal(response.data.data.total);
    } else setList([]);
    setLoading(false);
  };

  const handleFilter = (e, date = null) => {
    e.persist();
    let name = "";
    if (e.target.name === "name") name = e.target.value;
    if (date != null && date != undefined && date != "")
      date = moment(date).format("yyyy-MM-DD");
    else date = "";
    getCreatedList(api.communityList + `?page=${pageNum}&limit=${communityLIMIT}&search=${name}&date=${date}`);
  };

  const handleFileChange = (event, setFieldValue) => {
    const files = Array.from(event.target.files);
    if (files.length + selectedImages.length > 3) {
      alert("You can upload a maximum of 3 files.");
      return;
    }
    const imageUrls = files.map((file) => ({
      file,
      isLive: false,
      preview: URL.createObjectURL(file),
    }));
    setSelectedImages((prev) => [...prev, ...imageUrls]);
    setFieldValue("files", [...selectedImages, ...imageUrls]);
  };

  const removeImage = (index, setFieldValue, id = null) => {
    if (id != null) {
      const updatedCommunityImages = selectedCommunityImages.filter(
        (_, i) => i !== index
      );
      setSelectedCommunityImages(updatedCommunityImages);
      setSelectedDeleteImages((prev) => [...prev, id]);
    } else {
      const updatedImages = selectedImages.filter((_, i) => i !== index);
      setSelectedImages(updatedImages);
      setFieldValue("files", updatedImages);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getCreatedList(
      api.communityList + `?page=${pageNum}&limit=${communityLIMIT}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="care-community-section">
          <div className="community-title-header">
            <h2 className="heading-title">My Community</h2>
            <div className="search-filter wd50">
              <div className="row g-2">
                <div className="col-md-2">
                  <Link
                    className="btn-gr wd100"
                    to=""
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </Link>
                </div>
                <div className="col-md-3">
                  <Link
                    className="btn-bl wd100"
                    to=""
                    onClick={(e) => {
                      e.preventDefault();
                      setCreate({ status: true });
                    }}
                  >
                    Create New
                  </Link>
                </div>
                <div className="col-md-7">
                  <div className="form-group mb-0">
                    <div className="search-form-group">
                      <input
                        type="text"
                        onChange={(e) => handleFilter(e)}
                        name="name"
                        className="form-control"
                        placeholder="Search By Community Name"
                      />
                      <span className="search-icon">
                        <img src={SearchImg} />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {list?.length !== 0 &&
            list !== "" &&
            list !== null &&
            list !== undefined ? (
              list?.map((ele, indx) => {
                return (
                  <div key={indx} className="col-md-4">
                    <div className="community-card">
                      <div className="community-head">
                        <div className="community-head-media">
                          {ele.profile_image === null ||
                          ele.profile_image === "" ||
                          ele.profile_image === undefined ? (
                            <img src={NoImage} alt="" />
                          ) : (
                            <img src={ele.profile_image} alt="" />
                          )}
                        </div>
                        <div className="community-head-content text-capitalize">
                          <h4>{ele.fullname ?? "NA"}</h4>
                        </div>
                        <div className="community-head-action">
                          <Link
                            className="view-font-btn"
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(routes.communityInfo, {
                                state: {
                                  id: encode(ele.id),
                                },
                              });
                            }}
                          >
                            <img width={23} src={RightArrow} />
                          </Link>
                          <Link
                            className="edit-btn mx-2"
                            to=""
                            onClick={() => {
                              setEditCommunity({
                                status: true,
                                id: ele.id,
                                title: ele.title,
                                description: ele.description,
                                cover_image: ele.cover_image,
                              });
                              setSelectedCommunityImages(ele.cover_image);
                            }}
                          >
                            <img src={Edit2} />
                          </Link>
                          <Link
                            className="delete-btn"
                            to=""
                            onClick={() =>
                              setDeleteCommunity({ status: true, id: ele.id })
                            }
                          >
                            <img src={TrashImg} />
                          </Link>
                        </div>
                      </div>
                      <div className="community-image">
                        <CarouselProvider
                          id="Main-Slider"
                          naturalSlideWidth={100}
                          naturalSlideHeight={50}
                          totalSlides={
                            ele.cover_image.length !== 0
                              ? ele.cover_image.length
                              : 1
                          }
                          isPlaying={true}
                        >
                          <Slider>
                            {ele.cover_image.length !== 0 ||
                            ele.cover_image !== null ||
                            ele.cover_image !== "" ||
                            ele.cover_image !== undefined ? (
                              ele.cover_image.map((ele, indx) => {
                                return (
                                  <Slide key={indx} index={indx}>
                                    <div className="item">
                                      <div className="Main-Slider-media">
                                        <img src={ele.image} alt="Cover" />
                                      </div>
                                    </div>
                                  </Slide>
                                );
                              })
                            ) : (
                              <img src={NoImage} alt="" />
                            )}
                          </Slider>
                        </CarouselProvider>
                      </div>
                      <div className="community-content">
                        <h3 className="text-capitalize">{ele.title ?? "NA"}</h3>
                        <p>{ele.description ?? "NA"}</p>
                        <div className="community-folllow-user">
                          <div className="community-folllow-media">
                            {ele?.last_following_member_images?.length !== 0 ? (
                              ele?.last_following_member_images?.map(
                                (element, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className={
                                        "folllow-user-image image" +
                                        `${index + 1}`
                                      }
                                    >
                                      {element === null ||
                                      element === "" ||
                                      element === undefined ? (
                                        <img src={NoImage} alt="No profile" />
                                      ) : (
                                        <img
                                          src={element}
                                          alt={`Member ${index + 1}`}
                                        />
                                      )}
                                    </div>
                                  );
                                }
                              )
                            ) : (
                              <div className="folllow-user-image image1">
                                <img src={NoImage} alt="No profile" />
                              </div>
                            )}
                          </div>
                          <div className="folllow-user-text">
                            {ele.member_count ?? 0} Followers
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "5% 0",
                }}
              >
                <img width={300} src={NoData} alt="" />
              </div>
            )}
          </div>
          <div className="d-flex align-items-center justify-content-center mt-3">
            {list?.length !== 0 ? (
              <div className="care-table-pagination">
                <ul className="care-pagination">
                  {pageNum !== 1 && (
                    <li
                      className="disabled"
                      id="example_previous"
                      onClick={() => setPageNum(pageNum - 1)}
                    >
                      <Link
                        to=""
                        aria-controls="example"
                        data-dt-idx="0"
                        tabIndex="0"
                        className="page-link"
                      >
                        Previous
                      </Link>
                    </li>
                  )}

                  {totalPageCalculator(total, communityLIMIT).length === 1
                    ? null
                    : totalPageCalculator(total, communityLIMIT).map(
                        (pageNo, indx) => {
                          return (
                            <li
                              className={pageNo === pageNum ? "active" : ""}
                              key={indx}
                              onClick={() => setPageNum(pageNo)}
                            >
                              <Link to="" className="page-link">
                                {pageNo}
                              </Link>
                            </li>
                          );
                        }
                      )}

                  {pageNum !== Math.ceil(total / communityLIMIT) && (
                    <li
                      className="next"
                      id="example_next"
                      onClick={() => setPageNum(pageNum + 1)}
                    >
                      <Link
                        to=""
                        aria-controls="example"
                        data-dt-idx="7"
                        tabIndex="0"
                        className="page-link"
                      >
                        Next
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <Modal
        show={deleteCommunity.status}
        onHide={() => {
          setDeleteCommunity({ status: false, id: null });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Community</h5>
                <p className="text-center">
                  Deleting this community cannot be undone. Are you sure you
                  want to proceed ?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() =>
                    setDeleteCommunity({ status: false, id: null })
                  }
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => deleteMyCommunity()}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={editCommunity.status}
        onHide={() => {
          setEditCommunity({
            status: false,
            id: null,
            title: null,
            description: null,
            cover_image: null,
          });
        }}
        className="modal-xl"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Community</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialEditValues}
                validateOnChange={true}
                validationSchema={validationEditSchema}
                onSubmit={updateCommunity}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form" id="update-community-form">
                    <div className="form-group">
                      <h4>Title</h4>
                      <Field
                        type="text"
                        className="form-control todo-list-input"
                        name="title"
                        placeholder="Enter Title"
                      />
                      <ErrorMessage
                        name="title"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group">
                      <h4>
                        Upload Image(s){" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.7rem" }}
                        >
                          (In JPG, JPEG, & PNG)
                        </span>
                      </h4>
                      <div className="upload-signature">
                        <Field name="files">
                          {({ field, form }) => (
                            <div>
                              <input
                                type="file"
                                multiple
                                accept="image/jpg, image/jpeg, image/png"
                                className="form-control"
                                onChange={(event) =>
                                  handleFileChange(event, setFieldValue)
                                }
                              />
                            </div>
                          )}
                        </Field>
                        <ErrorMessage
                          name="files"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                    </div>
                    <div className="row mb-3 mx-1">
                      {selectedCommunityImages?.map((img, index) => (
                        <div
                          key={index}
                          className="col-md-2 d-flex flex-column align-items-center"
                        >
                          <div className="mb-2">
                            <Link to={img.image} target="_blank">
                              <img
                                style={{
                                  borderRadius: "8px",
                                  objectFit: "cover",
                                  objectPosition: "center",
                                  width: "160px",
                                  height: "100px",
                                }}
                                src={img.image}
                                alt=""
                              />
                            </Link>
                          </div>
                          <div>
                            <button
                              type="button"
                              className="delete-btn"
                              onClick={() => {
                                removeImage(
                                  index,
                                  setFieldValue,
                                  img.id ?? null
                                );
                              }}
                            >
                              <img src={TrashImg} />
                            </button>
                          </div>
                        </div>
                      ))}
                      {selectedImages.map((img, index) => (
                        <div
                          key={index}
                          className="col-md-2 d-flex flex-column align-items-center"
                        >
                          <div className="mb-2">
                            <Link to={img.preview} target="_blank">
                              <img
                                style={{
                                  borderRadius: "8px",
                                  objectFit: "cover",
                                  objectPosition: "center",
                                  width: "160px",
                                  height: "100px",
                                }}
                                src={img.preview}
                                alt=""
                              />
                            </Link>
                          </div>
                          <div>
                            <button
                              type="button"
                              className="delete-btn"
                              onClick={() => {
                                removeImage(index, setFieldValue);
                              }}
                            >
                              <img src={TrashImg} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="form-group">
                      <h4>Description</h4>
                      <Field
                        type="text"
                        as="textarea"
                        className="form-control"
                        name="description"
                        placeholder="Enter Description"
                        style={{ height: "150px" }}
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group text-end">
                      <button
                        type="button"
                        onClick={() => {
                          setEditCommunity({
                            status: false,
                            id: null,
                            title: null,
                            description: null,
                            cover_image: null,
                          });
                        }}
                        className="btn btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-gr me-2"
                        data-bs-dismiss="modal"
                      >
                        Update
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={creation.status}
        onHide={() => {
          setCreate({
            status: false,
          });
        }}
        className="modal-xl"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Create Community</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={createCommunity}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form" id="add-community-form">
                    <div className="form-group">
                      <h4>Title</h4>
                      <Field
                        type="text"
                        className="form-control todo-list-input"
                        name="title"
                        placeholder="Enter Title"
                      />
                      <ErrorMessage
                        name="title"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group">
                      <h4>
                        Upload Image(s){" "}
                        <span
                          className="text-danger"
                          style={{ fontSize: "0.7rem" }}
                        >
                          (In JPG, JPEG & PNG)
                        </span>
                      </h4>
                      <div className="upload-signature">
                        <Field name="files">
                          {({ field, form }) => (
                            <div>
                              <input
                                type="file"
                                multiple
                                accept="image/jpg, image/jpeg, image/png"
                                className="form-control"
                                onChange={(event) => {
                                  const files = Array.from(
                                    event.currentTarget.files
                                  );
                                  setFieldValue("files", files);
                                }}
                              />
                            </div>
                          )}
                        </Field>
                        <ErrorMessage
                          name="files"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <h4>Description</h4>
                      <Field
                        type="text"
                        as="textarea"
                        className="form-control"
                        name="description"
                        placeholder="Enter Description"
                        style={{ height: "150px" }}
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group text-end">
                      <button
                        type="button"
                        onClick={() => {
                          setCreate({
                            status: false,
                          });
                        }}
                        className="btn btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-gr me-2"
                        data-bs-dismiss="modal"
                      >
                        Add
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default MyCommunity;
